import axios, { AxiosRequestConfig } from 'axios';
import qs from 'qs';
import { Query } from '@ordermentum/ui-types';
import { AsyncThunkDispatch } from '@ordermentum/ui-definitions';
import C from '../../constants';

const payInvoiceRequest = () => ({
  type: C.PAY_INVOICE_REQUEST,
});

const payInvoiceSuccess = data => ({
  type: C.PAY_INVOICE_SUCCESS,
  data,
});

const payInvoiceError = error => ({
  type: C.PAY_INVOICE_ERROR,
  error,
});

export const fetchInvoicesRequest = (filter: string) => ({
  type: C.FETCH_INVOICES_REQUEST,
  filter,
});

export const fetchInvoicesSuccess = data => ({
  type: C.FETCH_INVOICES_SUCCESS,
  data,
});

export const fetchInvoicesFailure = () => ({
  type: C.FETCH_INVOICES_ERROR,
});

export type FetchInvoicesAsync = (query: Query) => AsyncThunkDispatch;
export const fetchInvoicesAsync =
  (
    query: Query = {
      supplierId: '',
      pageSize: 25,
      pageNo: 1,
      search: '',
    },
    supplierId?: string
  ) =>
  async (dispatch: AsyncThunkDispatch) => {
    dispatch(fetchInvoicesRequest(query.search ? query.search : ''));

    const q = qs.stringify({
      ...query,
    });

    const url = `/v1/invoices?${q}`;
    try {
      const axiosConfig: AxiosRequestConfig = {
        url,
        method: 'GET',
        responseType: 'json',
      };

      if (supplierId) {
        axiosConfig.headers = {
          'context-entity': 'supplier',
          'context-id': supplierId,
        };
      }

      const res = await axios(axiosConfig);
      return dispatch(fetchInvoicesSuccess(res.data));
    } catch (ex) {
      return dispatch(fetchInvoicesFailure());
    }
  };

// EMAIL INVOICE ACTION
const emailRequest = () => ({
  type: C.EMAIL_INVOICE_REQUEST,
});

const emailSuccess = invoice => ({
  type: C.EMAIL_INVOICE_SUCCESS,
  data: invoice,
});

const emailError = err => ({
  type: C.EMAIL_INVOICE_ERROR,
  data: err,
});

const sendInvoiceEmail =
  ({ data }) =>
  dispatch => {
    dispatch(emailRequest());

    return axios({
      url: `/v1/invoices/${data.includedIds[0]}/email`,
      method: 'POST',
    })
      .then(res => {
        dispatch(emailSuccess(res.data));
        return dispatch({
          type: C.NOTIFY_SEND_INVOICE_EMAIL_SUCCESS,
          notificationPayload: 'Invoice successfully emailed',
          notificationDelay: C.NOTIFICATION_DELAY,
          notificationType: 'success',
        });
      })
      .catch(err => {
        dispatch(emailError(err.data));
        return dispatch({
          type: C.NOTIFY_SEND_INVOICE_EMAIL_ERROR,
          notificationPayload: 'There was an error emailing the invoice.',
          notificationDelay: C.NOTIFICATION_DELAY,
          notificationType: 'error',
        });
      });
  };

const payInvoiceAsync =
  ({ id, paymentRequestId, paymentMethodId, token }) =>
  async dispatch => {
    dispatch(payInvoiceRequest());

    try {
      dispatch({
        type: C.NOTIFY_PAY_INVOICE_PENDING,
        notificationPayload: 'Processing Payment',
        notificationDelay: C.NOTIFICATION_DELAY,
        notificationType: 'info',
      });
      const result = await axios({
        url: `/v1/payment-requests/${paymentRequestId}/invoice-pay`,
        method: 'POST',
        responseType: 'json',
        timeout: 20000,
        data: {
          id,
          paymentMethodId,
          token,
        },
      });
      dispatch({
        type: C.NOTIFY_PAY_INVOICE_SUCCESS,
        notificationPayload: 'Payment Successful',
        notificationDelay: C.NOTIFICATION_DELAY,
        notificationType: 'success',
      });
      dispatch(payInvoiceSuccess(result));
    } catch (error) {
      dispatch({
        type: C.NOTIFY_PAY_INVOICE_ERROR,
        notificationPayload: 'Payment Unsuccessful',
        notificationDelay: C.NOTIFICATION_DELAY,
        notificationType: 'error',
      });
      dispatch(payInvoiceError(error));
    }
  };

export {
  emailRequest,
  emailSuccess,
  emailError,
  sendInvoiceEmail,
  payInvoiceAsync,
};
